import React from "react";
import { css } from "glamor";
import { Icon, Tooltip } from "antd";
import * as R from "ramda";

const styles = {
    nameTooltipIcon: css({
        marginLeft: ".3rem",
        fontSize: "1.2rem",
        color: "#1b75bc",
    }),
    tooltipContent: css({
        fontSize: ".8rem",
    }),
    tooltipContentLink: css({
        color: "#FFF",
        textDecoration: "underline",
        marginTop: ".5rem",
        display: "block",
    }),
    tooltipContentTitle: css({
        fontSize: "1rem",
        marginBottom: ".5rem",
        color: "#FFF",
    }),
};

const EntityTooltipContent = props => {
    const { entity } = props;

    return (
        <div className={styles.tooltipContent}>
            <div className={styles.tooltipContentTitle}>{entity.name}</div>
            {R.values(
                R.mapObjIndexed(
                    (value, key) =>
                        value ? (
                            <div key={key}>
                                {key}: {value}
                            </div>
                        ) : null,
                    entity.properties
                )
            )}
            {entity.ulid && (
                <a
                    className={styles.tooltipContentLink}
                    href={`/beta/entities/${entity.ulid}`}
                >
                    View more on Entity Store
                </a>
            )}
        </div>
    );
};

const EntityTooltip = props => {
    const entityName = R.pathOr(false, ["entity", "name"], props);
    return entityName ? (
        <Tooltip
            placement="right"
            title={<EntityTooltipContent entity={props.entity} />}
        >
            <Icon className={`${styles.nameTooltipIcon}`} type="solution" />
        </Tooltip>
    ) : null;
};

EntityTooltip.defaultProps = {
    entity: {},
};

export default EntityTooltip;
